import { render, staticRenderFns } from "./resultadosExamenProfesional.vue?vue&type=template&id=1f636d65&scoped=true"
import script from "./resultadosExamenProfesional.vue?vue&type=script&lang=js"
export * from "./resultadosExamenProfesional.vue?vue&type=script&lang=js"
import style0 from "./resultadosExamenProfesional.vue?vue&type=style&index=0&id=1f636d65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f636d65",
  null
  
)

export default component.exports